// extracted by mini-css-extract-plugin
export default {"root":"TrendCard_root__5XPD3","body":"TrendCard_body__UGZ8y"};